export const CustomersIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
    >
      <path
        d="M9.99984 12.3127C6.60583 12.3127 3.84351 9.55035 3.84351 6.15634C3.84351 2.76232 6.60583 0 9.99984 0C13.3939 0 16.1562 2.76232 16.1562 6.15634C16.1562 9.55035 13.3939 12.3127 9.99984 12.3127ZM9.99984 1.606C7.49448 1.606 5.44951 3.65098 5.44951 6.15634C5.44951 8.6617 7.49448 10.7067 9.99984 10.7067C12.5052 10.7067 14.5502 8.6617 14.5502 6.15634C14.5502 3.65098 12.5052 1.606 9.99984 1.606Z"
        fill="#292D32"
      />
      <path
        d="M19.197 23.0194C18.758 23.0194 18.394 22.6553 18.394 22.2164C18.394 18.5226 14.6254 15.5247 10.0001 15.5247C5.37474 15.5247 1.606 18.5226 1.606 22.2164C1.606 22.6553 1.24197 23.0194 0.803 23.0194C0.364027 23.0194 0 22.6553 0 22.2164C0 17.6446 4.48609 13.9187 10.0001 13.9187C15.514 13.9187 20 17.6446 20 22.2164C20 22.6553 19.636 23.0194 19.197 23.0194Z"
        fill="#292D32"
      />
    </svg>
  );
};
